import { createAction } from 'typesafe-actions';
import {
  BlockManagerAddContactRequest,
  BlockManagerGetFlatRequest,
  BlockManagerGetFlatsRequest,
  BlockManagerGetPropertiesRequest,
  BlockManagerUpdateContactRequest,
  BlockManagerListContactsRequest,
  EngageFlatIsHMO,
  EngageFlatIsCommerciallyOwned,
  FlatResidentSurvey,
} from 'types/DTOs/BlockManagerDTOs';
import {
  EngageFlatContact,
  EngageFlatListItem,
  EngageFlatsFilter,
  EngagePropertiesFilter,
  EngagePropertyListItem,
} from 'types/Engage';

export const doEngageClearData = createAction('doEngageClearData')<{
  key: string;
}>();

export const doEngageSetLoadState = createAction('doEngageSetLoadState')<{
  key: string;
  loading: boolean;
}>();

/**
 * Properties
 */

export const doEngagePropertiesLoad = createAction('doEngagePropertiesLoad')<{
  key: string;
  page: 'reset' | 'next';
}>();

export const doEngagePropertiesSetData = createAction(
  'doEngagePropertiesSetData',
)<{
  key: string;
  response: BlockManagerGetPropertiesRequest['response'];
  clearData: boolean;
  pageNumber: number;
}>();

export const doEngagePropertiesSetFilter = createAction(
  'doEngagePropertiesSetFilter',
)<{
  key: string;
  data: Partial<EngagePropertiesFilter>;
  replace?: boolean;
}>();

/**
 * Flats
 */

export const doEngageFlatsLoad = createAction('doEngageFlatsLoad')<{
  propertyId: string;
  key: string;
  page: 'reset' | 'next';
}>();

export const doEngageFlatsSetFilter = createAction('doEngageFlatsSetFilter')<{
  key: string;
  data: Partial<EngageFlatsFilter>;
  replace?: boolean;
}>();

export const doEngageOnboard = createAction('doEngageOnboard')<{
  propertyId: string;
  key: string;
}>();

export const doEngageFlatsSetData = createAction('doEngageFlatsSetData')<{
  key: string;
  response: BlockManagerGetFlatsRequest['response'];
  clearData: boolean;
  pageNumber: number;
}>();

export const doEngageFlatsClearData = createAction('doEngageFlatsClearData')<{
  key: string;
}>();

/**
 * Flat
 */

export const doEngageFlatLoad = createAction('doEngageFlatLoad')<{
  key: string;
  property: EngagePropertyListItem;
  flat: EngageFlatListItem;
}>();

export const doEngageFlatSetData = createAction('doEngageFlatSetData')<{
  key: string;
  property: EngagePropertyListItem;
  flat: EngageFlatListItem;
  response: BlockManagerGetFlatRequest['response'];
}>();

export const doEngageFlatUpdateData = createAction('doEngageFlatUpdateData')<{
  key: string;
  occupationStatus?: EngageFlatListItem['occupationStatus'];
  isHMO?: EngageFlatIsHMO;
  isCommerciallyOwned?: EngageFlatIsCommerciallyOwned;
  residentSurvey?: FlatResidentSurvey;
  archivedContactIds?: string[];
  unarchivedContactIds?: string[];
  contacts?: BlockManagerGetFlatRequest['response']['contacts'];
  communications?: BlockManagerGetFlatRequest['response']['communications'];
}>();

export const doEngageFlatChangeOccupationStatus = createAction(
  'doEngageFlatChangeOccupationStatus',
)<{
  key: string;
}>();

export const doEngageFlatChangeIsHMO = createAction('doEngageFlatChangeIsHMO')<{
  key: string;
}>();

export const doEngageFlatChangeIsCommerciallyOwned = createAction(
  'doEngageFlatChangeIsCommerciallyOwned',
)<{
  key: string;
}>();

/**
 * Contacts
 */
export const doEngageFlatArchivedContactsLoad = createAction(
  'doEngageFlatArchivedContactsLoad',
)<{
  key: string;
  propertyId: string;
  flatId: string;
}>();

export const doEngageFlatArchivedContactsSet = createAction(
  'doEngageFlatArchivedContactsSet',
)<{
  key: string;
  contacts: BlockManagerListContactsRequest['response']['contacts'];
}>();

export const doEngageArchiveContact = createAction('doEngageArchiveContact')<{
  key: string;
  propertyId: string;
  flatId: string;
  contactId: string;
}>();

export const doEngageUnarchiveContact = createAction(
  'doEngageUnarchiveContact',
)<{
  key: string;
  propertyId: string;
  flatId: string;
  contactId: string;
}>();

export const doEngageSaveContact = createAction('doEngageSaveContact')<{
  key: string;
  propertyId: string;
  flatId: string;
  isNew: boolean;
  contact: EngageFlatContact;
}>();

export const doEngageContactUpdate = createAction('doEngageContactUpdate')<{
  key: string;
  isNew: boolean;
  propertyId: string;
  flatId: string;
  contact:
    | BlockManagerAddContactRequest['response']['contact']
    | BlockManagerUpdateContactRequest['response']['contact'];
}>();

/**
 * Communication
 */

export const doEngageSendCommunication = createAction(
  'doEngageSendCommunication',
)<{
  key: string;
  propertyId: string;
  flatId: string;
  communicationId: string;
  contactIds: string[];
}>();
